import { SMLRouteNames } from '../../routing/sml/SMLRoutes';

/** The last part of the editor route: `/catalog/song/<uuid>/music-video`. */
export const MUSIC_VIDEO_EDITOR_SEGMENT = 'music-video';

export interface MusicVideoEditorPathOptions {
  /** The artist of the row; the web switcher reads it. */
  accountId?: number | null;
  /** The cut to open. With none, the editor opens the newest cut. */
  cut?: string | null;
  /** The page that opened the editor (a path inside the app): "Back" returns to it. */
  from?: string | null;
}

/**
 * The path of the music video editor of one song (design music-video b1):
 * `/catalog/song/<uuid>/music-video[?accountId=<id>][&cut=<uuid>][&from=<path>]`. The router adds
 * `/app`. The Kit slot, the Catalog field and the Studio card link here.
 */
export function musicVideoEditorPath(catalogItemUuid: string, options: MusicVideoEditorPathOptions = {}): string {
  const query = new URLSearchParams();
  if (options.accountId !== undefined && options.accountId !== null) {
    query.set('accountId', String(options.accountId));
  }
  if (options.cut !== undefined && options.cut !== null && options.cut !== '') {
    query.set('cut', options.cut);
  }
  if (options.from !== undefined && options.from !== null && options.from !== '') {
    query.set('from', options.from);
  }
  const search = query.toString();
  return `/${SMLRouteNames.catalog}/song/${encodeURIComponent(catalogItemUuid)}/${MUSIC_VIDEO_EDITOR_SEGMENT}${
    search === '' ? '' : `?${search}`
  }`;
}
